/* Ghost Town Seeds VapoFinder
   Ohjattu vaporisaattorihaku. Ei riippuvuuksia; toimii standalone ja Shopify-teemassa. */
(function (global) {
  'use strict';

  /* ---------- Apurit ---------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.87 6.48.94-4.69 4.57 1.11 6.45L12 17.77l-5.8 3.05 1.11-6.45L2.62 9.8l6.48-.94z"/></svg>';

  /* ---------- Kysymyskorttien ikonit (ohutviiva, currentColor) ---------- */
  var ICONS = {
    // Käyttöpaikka
    'use-portable': '<rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M10.5 5 H13.5"/><path d="M12 18.5 H12.01"/>',
    'use-home': '<path d="M4 21 V10 L12 3 L20 10 V21 Z"/><path d="M9.5 21 V15 H14.5 V21"/>',
    'use-both': '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
    // Materiaali
    'mat-herb': '<path d="M12 21 V11"/><path d="M12 11 C 12 7 14.5 5 18.5 5 C 18.5 9 16 11 12 11 Z"/>',
    'mat-conc': '<path d="M12 3 C 12 3 5.5 11 5.5 15 A 6.5 6.5 0 0 0 18.5 15 C 18.5 11 12 3 12 3 Z"/>',
    'mat-both': '<circle cx="12" cy="12" r="9"/><path d="M12 3 V21"/>',
    // Virtalähde
    'pow-electric': '<path d="M13 2 L4.5 13.5 H11 L10 22 L19.5 10.5 H13 Z"/>',
    'pow-flame': '<path d="M12 3 C 13 7 17 8.5 17 13.5 A 5 5 0 0 1 7 13.5 C 7 10.5 10 8.5 10 5.5 C 11 6.5 12 6.5 12 3 Z"/>',
    'pow-any': '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
    // Lämmitystekniikka
    'heat-convection': '<path d="M3 8 H14 A 3 3 0 1 0 11 5"/><path d="M3 13 H19 A 3 3 0 1 1 16 16"/><path d="M3 18 H11"/>',
    'heat-conduction': '<rect x="4" y="13" width="16" height="6" rx="1.5"/><path d="M8 9.5 C 8 8 9 7.5 9 6.5"/><path d="M12 9.5 C 12 8 13 7.5 13 6.5"/><path d="M16 9.5 C 16 8 17 7.5 17 6.5"/>',
    'heat-any': '<circle cx="12" cy="12" r="9"/><path d="M8.5 14 C 10 16 14 16 15.5 14"/><path d="M9 9.5 H9.01"/><path d="M15 9.5 H15.01"/>',
    // Budjetti
    'price-low': '<circle cx="12" cy="12" r="9"/><path d="M12 7 V17"/><path d="M15 9.5 C 14 8 10.5 8 9.5 9.5 C 8.5 11 10 12 12 12 C 14 12 15.5 13 14.5 14.5 C 13.5 16 10 16 9 14.5"/>',
    'price-mid': '<circle cx="8.5" cy="14" r="6.5"/><circle cx="15.5" cy="10" r="6.5"/>',
    'price-high': '<path d="M3 17 L9 11 L13 15 L21 7"/><path d="M15 7 H21 V13"/>',
    'price-any': '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
    // Lämpötilansäätö
    'temp-precise': '<path d="M10 3.5 A 2 2 0 0 1 14 3.5 V14 A 4.5 4.5 0 1 1 10 14 Z"/><path d="M12 8 V15"/><circle cx="12" cy="16.5" r="1.6"/>',
    'temp-simple': '<circle cx="12" cy="12" r="9"/><path d="M8 12 H16"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  /* ---------- Normalisointi (yksi totuuden lähde, tageista) ------------- */
  function tagStr(p) { return (p.tags || []).join(' | ').toLowerCase(); }
  function hasTag(p, needle) { return tagStr(p).indexOf(needle.toLowerCase()) > -1; }

  function placeCat(p) {
    if (hasTag(p, 'pöytävaporisaattori')) return 'desktop';
    if (hasTag(p, 'kannettav')) return 'portable';
    return 'portable';
  }
  function materialCat(p) {
    var conc = hasTag(p, 'konsentraat') || hasTag(p, 'ekstrakt') || hasTag(p, 'tiiviste') || hasTag(p, 'concentrate') || hasTag(p, 'dab');
    var herb = hasTag(p, 'kuivayrtti') || hasTag(p, 'dry herb');
    if (hasTag(p, 'dual use')) return 'dual';
    if (conc && herb) return 'dual';
    if (conc) return 'conc';
    if (herb) return 'herb';
    // DynaVapit yms. manuaalit ovat kuivayrttilaitteita, vaikka tagi puuttuisi.
    return 'herb';
  }
  function powerCat(p) {
    if (hasTag(p, 'manuaalinen') || hasTag(p, 'analogi') || hasTag(p, 'akuton')) return 'manual';
    return 'electric';
  }
  function heatingCat(p) {
    var conv = hasTag(p, 'konvektio'), cond = hasTag(p, 'konduktio');
    if (conv && cond) return 'hybrid';
    if (conv) return 'convection';
    if (cond) return 'conduction';
    return null;
  }

  function normalize(p) {
    return {
      raw: p,
      title: p.title, handle: p.handle, vendor: p.vendor,
      image: p.image, price: p.price,
      available: p.available !== false,
      place: placeCat(p),
      material: materialCat(p),
      power: powerCat(p),
      heating: heatingCat(p),
      tempCtl: hasTag(p, 'lämpötilansäätö'),
      bongCompat: hasTag(p, 'vesipiippu') || hasTag(p, 'bong adapteri')
    };
  }

  var PLACE_LABEL = { portable: 'Kannettava', desktop: 'Pöytälaite' };
  var MATERIAL_LABEL = { herb: 'Kuivayrtti', conc: 'Konsentraatti', dual: 'Kuivayrtti + konsentraatti' };
  var HEATING_LABEL = { convection: 'Konvektio', conduction: 'Konduktio', hybrid: 'Hybridilämmitys' };

  /* ---------- Kysymykset ------------------------------------------------ */
  // score(answer, n) -> { p, max }  (max 0 = ei vaikuta prosenttiin)
  var QUESTIONS = [
    {
      id: 'place',
      q: 'Missä käyttäisit laitetta eniten?',
      help: 'Kannettava kulkee mukana, pöytälaite on kotikäytön järeämpi valinta.',
      options: [
        { value: 'portable', icon: 'use-portable', label: 'Liikkeellä', sub: 'Kompakti ja akkukäyttöinen' },
        { value: 'desktop', icon: 'use-home', label: 'Kotona', sub: 'Pöytälaite, täysi teho' },
        { value: 'both', icon: 'use-both', label: 'Ei väliä', sub: 'Näytä molemmat' }
      ],
      score: function (a, n) {
        var W = 3;
        if (a === 'portable') return { p: n.place === 'portable' ? W : 0, max: W };
        if (a === 'desktop') return { p: n.place === 'desktop' ? W : 0, max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'material',
      q: 'Mitä aiot höyrystää?',
      help: 'Osa laitteista on suunniteltu kuivayrteille, osa konsentraateille — jotkut molemmille.',
      options: [
        { value: 'herb', icon: 'mat-herb', label: 'Kuivayrttejä', sub: 'Klassinen yrttikammio' },
        { value: 'conc', icon: 'mat-conc', label: 'Konsentraatteja', sub: 'Ekstraktit, öljyt ja vahat' },
        { value: 'both', icon: 'mat-both', label: 'Molempia', sub: 'Monikäyttöinen laite' }
      ],
      score: function (a, n) {
        var W = 3;
        if (a === 'herb') return { p: n.material === 'herb' ? W : (n.material === 'dual' ? W * 0.8 : 0), max: W };
        if (a === 'conc') return { p: n.material === 'conc' ? W : (n.material === 'dual' ? W * 0.8 : 0), max: W };
        if (a === 'both') return { p: n.material === 'dual' ? W : W * 0.3, max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'power',
      q: 'Kumpi lämmitys sopii sinulle?',
      help: 'Sähköinen on helppo ja tarkka; liekkilämmitteinen (esim. DynaVap) toimii ilman akkua.',
      options: [
        { value: 'electric', icon: 'pow-electric', label: 'Sähköinen', sub: 'Akku tai verkkovirta, helppo käyttää' },
        { value: 'flame', icon: 'pow-flame', label: 'Liekkilämmitteinen', sub: 'Akuton, mekaaninen (esim. DynaVap)' },
        { value: 'any', icon: 'pow-any', label: 'Ei väliä', sub: 'Näytä kaikki' }
      ],
      score: function (a, n) {
        var W = 2;
        if (a === 'electric') return { p: n.power === 'electric' ? W : 0, max: W };
        if (a === 'flame') return { p: n.power === 'manual' ? W : 0, max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'heating',
      q: 'Millaista lämmitystekniikkaa suosit?',
      help: 'Konvektio = kuuma ilma virtaa yrtin läpi (maukas höyry). Konduktio = kontaktilämpö (nopea ja tasainen). Hybridi yhdistää molemmat.',
      options: [
        { value: 'convection', icon: 'heat-convection', label: 'Konvektio', sub: 'Ilmavirtalämmitys, paras maku' },
        { value: 'conduction', icon: 'heat-conduction', label: 'Konduktio', sub: 'Kontaktilämpö, nopea ja tehokas' },
        { value: 'any', icon: 'heat-any', label: 'Ei väliä', sub: 'Molemmat käyvät' }
      ],
      score: function (a, n) {
        var W = 2;
        if (a === 'convection') return { p: n.heating === 'convection' ? W : (n.heating === 'hybrid' ? W * 0.85 : 0), max: W };
        if (a === 'conduction') return { p: n.heating === 'conduction' ? W : (n.heating === 'hybrid' ? W * 0.85 : 0), max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'budget',
      q: 'Mikä on budjettisi?',
      help: 'Valikoimassa on laitteita 59 eurosta lähtien aina premium-tasolle asti.',
      options: [
        { value: 'low', icon: 'price-low', label: 'Alle 150 €', sub: 'Edullinen aloitus' },
        { value: 'mid', icon: 'price-mid', label: '150–300 €', sub: 'Keskitaso, paras hinta/laatu' },
        { value: 'high', icon: 'price-high', label: 'Yli 300 €', sub: 'Premium-laitteet' },
        { value: 'any', icon: 'price-any', label: 'Ei väliä', sub: 'Näytä kaikki' }
      ],
      score: function (a, n) {
        var W = 2.5;
        var pr = n.price || 0;
        if (a === 'low') return { p: pr < 150 ? W : (pr <= 200 ? W * 0.4 : 0), max: W };
        if (a === 'mid') return { p: (pr >= 150 && pr <= 300) ? W : (pr < 150 ? W * 0.6 : (pr <= 360 ? W * 0.4 : 0)), max: W };
        if (a === 'high') return { p: pr > 300 ? W : (pr >= 240 ? W * 0.5 : 0), max: W };
        return { p: 0, max: 0 };
      }
    },
    {
      id: 'temp',
      q: 'Kuinka tärkeä säädettävä lämpötila on?',
      help: 'Lämpötilan säätö vaikuttaa höyryn makuun ja tuntumaan.',
      options: [
        { value: 'important', icon: 'temp-precise', label: 'Tärkeä', sub: 'Haluan säätää lämpöä itse' },
        { value: 'any', icon: 'temp-simple', label: 'Ei niin tärkeä', sub: 'Kunhan laite toimii hyvin' }
      ],
      score: function (a, n) {
        var W = 1.5;
        if (a === 'important') return { p: n.tempCtl ? W : 0, max: W };
        return { p: 0, max: 0 };
      }
    }
  ];

  /* ---------- Pisteytys & syyt ------------------------------------------ */
  function scoreProduct(n, answers) {
    var num = 0, den = 0;
    QUESTIONS.forEach(function (Q) {
      if (!(Q.id in answers)) return;
      var r = Q.score(answers[Q.id], n, Q);
      num += r.p; den += r.max;
    });
    var pct = den > 0 ? Math.round((num / den) * 100) : 70;
    return { pct: clamp(pct, 0, 100), num: num, den: den };
  }

  function reasons(n, answers) {
    var out = [];
    if (answers.place === 'portable' && n.place === 'portable') out.push('Kulkee mukana');
    if (answers.place === 'desktop' && n.place === 'desktop') out.push('Kotikäytön tehopakkaus');
    if (answers.material === 'herb' && n.material === 'herb') out.push('Kuivayrteille suunniteltu');
    if (answers.material === 'conc' && n.material === 'conc') out.push('Konsentraateille suunniteltu');
    if ((answers.material === 'both' || answers.material === 'herb' || answers.material === 'conc') && n.material === 'dual') out.push('Sopii molemmille materiaaleille');
    if (answers.power === 'flame' && n.power === 'manual') out.push('Toimii ilman akkua');
    if (answers.power === 'electric' && n.power === 'electric') out.push('Helppo sähkölämmitys');
    if (answers.heating === 'convection' && n.heating === 'convection') out.push('Puhdas konvektio');
    if (answers.heating === 'conduction' && n.heating === 'conduction') out.push('Nopea konduktio');
    if ((answers.heating === 'convection' || answers.heating === 'conduction') && n.heating === 'hybrid') out.push('Hybridilämmitys');
    if (answers.budget === 'low' && n.price < 150) out.push('Budjettiystävällinen');
    if (answers.budget === 'high' && n.price > 300) out.push('Premium-luokka');
    if (answers.temp === 'important' && n.tempCtl) out.push('Säädettävä lämpötila');
    if (n.bongCompat) out.push('Vesipiippu-yhteensopiva');
    return out.slice(0, 3);
  }

  /* ---------- Widget ---------------------------------------------------- */
  function VapoFinderApp(root, products, opts) {
    this.root = root;
    this.baseUrl = (opts.baseUrl || '').replace(/\/$/, '');
    this.resultsCount = opts.resultsCount || 6;
    this.data = products.map(normalize);
    this.answers = {};
    this.step = -1; // -1 = intro
    this.onlyInStock = false;
    this.shown = null;
    this.render();
  }

  VapoFinderApp.prototype.render = function () {
    this.root.className = 'vapofinder';
    if (this.step === -1) return this.renderIntro();
    if (this.step >= QUESTIONS.length) return this.renderResults();
    return this.renderStep();
  };

  VapoFinderApp.prototype.renderIntro = function () {
    var self = this;
    this.root.innerHTML = '';
    var wrap = el('<div class="sf-step sf-intro"></div>');
    wrap.innerHTML =
      '<div class="sf-head">' +
        '<h2 class="sf-title">Löydä oma vaporisaattorisi</h2>' +
        '<p class="sf-sub">Vastaa muutamaan kysymykseen, niin ehdotamme sinulle parhaiten sopivat laitteet valikoimastamme.</p>' +
      '</div>' +
      '<div class="sf-intro-features">' +
        '<span><b>' + self.data.length + '</b>&nbsp;laitetta</span>' +
        '<span>' + QUESTIONS.length + ' kysymystä</span>' +
        '<span>Henkilökohtaiset suositukset</span>' +
      '</div>' +
      '<div class="sf-intro-actions"><div class="sf-intro-choices"></div></div>';
    var btn = el('<button class="sf-btn sf-btn-primary" type="button">Aloita haku <span class="sf-choice-count">' + self.data.length + '</span></button>');
    btn.addEventListener('click', function () { self.step = 0; self.render(); });
    wrap.querySelector('.sf-intro-choices').appendChild(btn);
    this.root.appendChild(wrap);
  };

  VapoFinderApp.prototype.renderStep = function () {
    var self = this, Q = QUESTIONS[this.step];
    this.root.innerHTML = '';

    var head = el('<div class="sf-progress"></div>');
    head.innerHTML =
      '<div class="sf-progress-meta"><span>Kysymys <strong>' + (this.step + 1) + '</strong> / ' + QUESTIONS.length + '</span>' +
      '<span>' + Math.round((this.step) / QUESTIONS.length * 100) + '%</span></div>' +
      '<div class="sf-progress-track"><div class="sf-progress-fill" style="width:' + (this.step / QUESTIONS.length * 100) + '%"></div></div>';
    this.root.appendChild(head);

    var step = el('<div class="sf-step"></div>');
    step.innerHTML = '<h2 class="sf-q">' + esc(Q.q) + '</h2><p class="sf-q-help">' + esc(Q.help) + '</p>';
    var optsWrap = el('<div class="sf-options"></div>');

    Q.options.forEach(function (o) {
      var selected = self.answers[Q.id] === o.value;
      var btn = el(
        '<button class="sf-option' + (selected ? ' is-selected' : '') + '" type="button">' +
          '<span class="sf-option-icon">' + icon(o.icon) + '</span>' +
          '<span class="sf-option-body"><span class="sf-option-label">' + esc(o.label) + '</span>' +
          (o.sub ? '<span class="sf-option-sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
          '<span class="sf-option-check">' + CHECK + '</span>' +
        '</button>');
      btn.addEventListener('click', function () {
        self.answers[Q.id] = o.value;
        self.step++;
        self.render();
      });
      optsWrap.appendChild(btn);
    });
    step.appendChild(optsWrap);

    var nav = el('<div class="sf-nav"></div>');
    var back = el('<button class="sf-btn sf-btn-ghost" type="button">Takaisin</button>');
    back.addEventListener('click', function () { self.step--; self.render(); });
    nav.appendChild(back);
    nav.appendChild(el('<div class="sf-spacer"></div>'));
    var skip = el('<button class="sf-btn sf-btn-ghost" type="button">Ohita</button>');
    skip.addEventListener('click', function () { delete self.answers[Q.id]; self.step++; self.render(); });
    nav.appendChild(skip);
    step.appendChild(nav);
    this.root.appendChild(step);
    window.scrollTo && this.root.scrollIntoView && this.root.scrollIntoView({ block: 'nearest' });
  };

  VapoFinderApp.prototype.computeResults = function () {
    var self = this;
    var scored = this.data.map(function (n) {
      var s = scoreProduct(n, self.answers);
      return { n: n, pct: s.pct, reasons: reasons(n, self.answers) };
    });
    scored.sort(function (a, b) {
      if (b.pct !== a.pct) return b.pct - a.pct;
      if (a.n.available !== b.n.available) return a.n.available ? -1 : 1;
      return (a.n.price || 0) - (b.n.price || 0);
    });
    return scored;
  };

  VapoFinderApp.prototype.renderResults = function () {
    var self = this;
    this.root.innerHTML = '';
    var all = this.computeResults();
    var list = this.onlyInStock ? all.filter(function (r) { return r.n.available; }) : all;
    if (this.shown == null) this.shown = 4;
    var top = list.slice(0, this.shown);

    var head = el('<div class="sf-step"></div>');
    var soldCount = all.filter(function (r) { return !r.n.available; }).length;
    head.innerHTML =
      '<div class="sf-results-head">' +
        '<h2 class="sf-q">Sinulle suositellut vaporisaattorit</h2>' +
        '<div class="sf-toolbar">' +
          '<label class="sf-switch"><input type="checkbox" id="sf-stock"' + (this.onlyInStock ? ' checked' : '') +
          '><span class="sf-switch-track"></span>Vain varastossa</label>' +
        '</div>' +
      '</div>' +
      '<p class="sf-results-sub">Parhaat osumat valikoimastamme, järjestettynä sopivuuden mukaan.' +
      (soldCount && !this.onlyInStock ? ' ' + soldCount + ' loppuunmyytyä mukana.' : '') + '</p>';
    this.root.appendChild(head);

    head.querySelector('#sf-stock').addEventListener('change', function (e) {
      self.onlyInStock = e.target.checked; self.shown = 4; self.render();
    });

    var grid = null;
    if (!top.length) {
      this.root.appendChild(el('<div class="sf-empty">Ei osumia näillä ehdoilla. Kokeile poistaa varastorajaus tai aloita alusta.</div>'));
    } else {
      grid = el('<div class="sf-grid"></div>');
      top.forEach(function (r, i) { grid.appendChild(self.card(r, i === 0)); });
      this.root.appendChild(grid);
    }

    if (grid && list.length > this.shown) {
      var moreWrap = el('<div class="sf-more"></div>');
      var moreBtn = el('<button class="sf-btn sf-btn-ghost" type="button"></button>');
      var setLabel = function () {
        moreBtn.textContent = self.shown < 12 ? 'Näytä lisää tuloksia' : ('Näytä kaikki (' + list.length + ')');
      };
      setLabel();
      moreBtn.addEventListener('click', function () {
        var end = self.shown < 12 ? Math.min(12, list.length) : list.length;
        list.slice(self.shown, end).forEach(function (r) { grid.appendChild(self.card(r, false)); });
        self.shown = end;
        if (self.shown >= list.length) moreWrap.remove(); else setLabel();
      });
      moreWrap.appendChild(moreBtn);
      this.root.appendChild(moreWrap);
    }

    var foot = el('<div class="sf-results-foot"></div>');
    var footActions = el('<div class="sf-foot-actions"></div>');

    if (list.length > 8) {
      var topBtn = el('<button class="sf-btn sf-btn-ghost" type="button">↑ Listan kärkeen</button>');
      topBtn.addEventListener('click', function () {
        self.root.scrollIntoView && self.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      footActions.appendChild(topBtn);
    }

    var restart = el('<button class="sf-btn sf-btn-ghost" type="button">↺ Aloita alusta</button>');
    restart.addEventListener('click', function () {
      self.answers = {}; self.step = -1; self.onlyInStock = false; self.shown = null; self.render();
    });
    footActions.appendChild(restart);
    foot.appendChild(footActions);
    foot.appendChild(el('<p class="sf-disclaimer">Suositukset perustuvat antamiisi vastauksiin ja laitteiden ominaisuuksiin. Vaporisaattorit on tarkoitettu laillisten yrttien ja uutteiden höyrystämiseen.</p>'));
    this.root.appendChild(foot);
    this.root.scrollIntoView && this.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  VapoFinderApp.prototype.card = function (r, isTop) {
    var n = r.n;
    var url = this.baseUrl + '/products/' + encodeURIComponent(n.handle);

    var specs = ['<span class="sf-spec">' + PLACE_LABEL[n.place] + '</span>',
      '<span class="sf-spec">' + MATERIAL_LABEL[n.material] + '</span>'];
    if (n.heating) specs.push('<span class="sf-spec">' + HEATING_LABEL[n.heating] + '</span>');
    if (n.power === 'manual') specs.push('<span class="sf-spec">Akuton</span>');

    var reasonHtml = r.reasons.map(function (x) { return '<span class="sf-reason">' + esc(x) + '</span>'; }).join('');

    var media = n.image
      ? '<img loading="lazy" src="' + esc(n.image) + '" alt="' + esc(n.title) + '" onerror="this.style.display=\'none\'">'
      : '';

    var card = el('<article class="sf-card' + (isTop ? ' is-top' : '') + '"></article>');
    card.innerHTML =
      '<div class="sf-card-media">' + media +
        '<span class="sf-match">Osuvuus ' + r.pct + '%</span>' +
        (isTop ? '<span class="sf-badge-top">' + STAR + 'Paras osuma</span>' : '') +
        (!n.available ? '<span class="sf-badge-sold">Loppuunmyyty</span>' : '') +
      '</div>' +
      '<div class="sf-card-body">' +
        '<div class="sf-card-vendor">' + esc(n.vendor) + '</div>' +
        '<div class="sf-card-title">' + esc(n.title) + '</div>' +
        '<div class="sf-specs">' + specs.join('') + '</div>' +
        (reasonHtml ? '<div class="sf-reasons">' + reasonHtml + '</div>' : '') +
        '<div class="sf-card-foot">' +
          '<div class="sf-price">' + formatPrice(n.price) + '</div>' +
          '<a class="sf-card-cta" href="' + esc(url) + '" target="_blank" rel="noopener">Katso tuote ' + ARROW + '</a>' +
        '</div>' +
      '</div>';
    return card;
  };

  function formatPrice(p) {
    if (p == null) return '';
    var s = (Math.round(p * 100) / 100).toFixed(2).replace('.', ',');
    return '€' + s;
  }

  /* ---------- Julkinen API --------------------------------------------- */
  var VapoFinder = {
    init: function (opts) {
      opts = opts || {};
      var mount = typeof opts.mount === 'string' ? document.querySelector(opts.mount) : opts.mount;
      if (!mount) { console.error('[VapoFinder] mount-elementtiä ei löytynyt'); return; }
      var products = opts.products || global.VAPOFINDER_PRODUCTS;

      var boot = function (data) {
        if (!data || !data.length) {
          mount.className = 'vapofinder';
          mount.innerHTML = '<div class="sf-state">Tuotetietoja ei löytynyt.</div>';
          return;
        }
        new VapoFinderApp(mount, data, opts);
      };

      if (products) return boot(products);

      mount.className = 'vapofinder';
      mount.innerHTML = '<div class="sf-state"><div class="sf-spinner"></div>Ladataan laitteita…</div>';
      var src = opts.dataUrl || 'data/vapos.json';
      fetch(src).then(function (r) { return r.json(); }).then(boot).catch(function (e) {
        console.error('[VapoFinder]', e);
        mount.innerHTML = '<div class="sf-state">Laitteiden lataus epäonnistui.</div>';
      });
    },

    // Liittää napin (opts.trigger), joka avaa VapoFinderin modaalina.
    attachModal: function (opts) {
      opts = opts || {};
      var triggerSel = typeof opts.trigger === 'string' ? opts.trigger : null;
      var triggerEl = (opts.trigger && typeof opts.trigger !== 'string') ? opts.trigger : null;
      if (!triggerSel && !triggerEl) { console.error('[VapoFinder] trigger puuttuu'); return; }

      var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

      var dialog = document.createElement('dialog');
      dialog.className = 'sf-modal';
      dialog.setAttribute('aria-label', opts.modalLabel || 'VapoFinder');
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'sf-modal-close';
      closeBtn.setAttribute('aria-label', 'Sulje');
      closeBtn.innerHTML = CLOSE;
      var panel = document.createElement('div');
      panel.className = 'sf-modal-panel';
      var mount = document.createElement('div');
      panel.appendChild(mount);
      dialog.appendChild(closeBtn);
      dialog.appendChild(panel);
      document.body.appendChild(dialog);

      var booted = false, lastFocus = null;

      function boot() {
        if (booted) return;
        booted = true;
        var o = { mount: mount };
        for (var k in opts) {
          if (opts.hasOwnProperty(k) && k !== 'trigger' && k !== 'mount' && k !== 'modalLabel') o[k] = opts[k];
        }
        VapoFinder.init(o);
      }
      function cleanup() {
        document.documentElement.classList.remove('sf-modal-open');
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      }
      function open(activator) {
        var af = activator || document.activeElement;
        lastFocus = (af && af !== document.body) ? af : (triggerEl || null);
        boot();
        document.documentElement.classList.add('sf-modal-open');
        if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
        else { dialog.classList.add('sf-modal--fallback'); dialog.setAttribute('open', ''); }
      }
      function close() {
        if (typeof dialog.close === 'function' && dialog.open) { dialog.close(); }
        else { dialog.removeAttribute('open'); }
        // Siivous suoraan eikä vain 'close'-eventin varassa (osa upotetuista
        // selaimista ei laukaise eventtiä). cleanup on idempotentti.
        cleanup();
      }

      if (triggerSel) {
        document.addEventListener('click', function (e) {
          var t = e.target && e.target.closest ? e.target.closest(triggerSel) : null;
          if (t) { e.preventDefault(); e.stopPropagation(); open(t); }
        }, true);
      } else {
        triggerEl.addEventListener('click', function (e) { e.preventDefault(); open(triggerEl); });
      }
      closeBtn.addEventListener('click', close);
      dialog.addEventListener('close', cleanup);   // Esc tai dialog.close()
      dialog.addEventListener('cancel', cleanup);  // varmistus Esc:lle
      dialog.addEventListener('click', function (e) {
        var r = dialog.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) close();
      });

      return { open: open, close: close, dialog: dialog };
    }
  };

  global.VapoFinder = VapoFinder;
})(window);
